// Linked Products "Learn more" popups (snippets/sm-main-product_navigation-info-modal.liquid).
// Dawn's modal-dialog handles open, Esc, focus and the backdrop; this adds the close button on
// each panel, closing from the gaps between stacked panels, and Show All for long model lists.
if (!window.smLinkedInfoBound) {
  window.smLinkedInfoBound = true;
  document.addEventListener('click', (event) => {
    const modal = event.target.closest('modal-dialog.sm-info');
    if (!modal) return;

    if (event.target.closest('[data-sm-info-close]') || event.target.classList.contains('sm-info__dialog')) {
      modal.hide();
      return;
    }

    const showAll = event.target.closest('[data-sm-info-show-all]');
    if (showAll) {
      const supports = showAll.closest('[data-sm-info-supports]');
      supports.querySelectorAll('[data-sm-info-more]').forEach((item) => {
        item.hidden = false;
      });
      showAll.hidden = true;
    }
  });
}
